import { jwtDecode } from 'jwt-decode';

export function getSubAbas() {
  let isUserAdmin = false;

  try {
    const token = localStorage.getItem('token');

    if (token) {
      const decoded: any = jwtDecode(token);
      const isAdminFromFlag = decoded?.admin === true;
      const papeis = decoded?.papel || [];

      isUserAdmin =
        isAdminFromFlag || (Array.isArray(papeis) && papeis.includes(1));
    }
  } catch (error) {
    console.warn('Erro ao decodificar token para subAbas:', error);
  }

  return [
    { label: 'Tickets', rota: '/daf/maisopcoes/tickets' },
    ...(isUserAdmin
      ? [
          { label: 'Tasks', rota: '/daf/maisopcoes/tasks' },
          { label: 'Documentos', rota: '/daf/maisopcoes/documentos' },
          { label: 'Notas de Versão', rota: '/daf/maisopcoes/notas' },
        ]
      : []),
  ];
}
// eslint-disable-next-line
